import store from '../store/index';
import { CONSTANTS } from '../config/constants';
import AuthService from './AuthService';

async function handleErrors(response: any) {
  if (!response.ok) {
    if (!response.statusText) {
      const jsonError = await response.json();
      if (jsonError.code === 209) {
        store.dispatch('logout');
        window.location.href = '/login';
      }
      console.log(jsonError);
      throw jsonError.error;
    }
    throw response.statusText;
  }
  return response;
}

function getHeaders(token?: string) {
  return {
    'Content-Type': 'application/json',
    'X-Parse-Application-Id': CONSTANTS.applicationId as string,
    'X-Parse-Session-Token': token || (store.state.auth.currentUser && store.state.auth.currentUser.sessionToken) || '',
    'x-omnichat-platform': 'web2',
  };
}

function getHeadersV2(token?: string) {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token || (store.state.auth.currentUser && store.state.auth.currentUser.sessionToken) || ''}`,
  };
}

function getCsvHeaders(token?: string) {
  return {
    'Content-Type': 'text/csv',
    ...getHeaders(token),
  };
}

function getFormDataHeaders() {
  return {
    'X-Parse-Session-Token': store.state.auth.currentUser && store.state.auth.currentUser.sessionToken || '',
  };
}

export async function get(path: string, sessionToken?: string) {
  const token = sessionToken || await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint}${path}`, {
    method: 'GET',
    headers: getHeaders(token),
  }).then((handleErrors)).then((res: any) => res.json());
}

export const post = async (path: string, data: any, withoutAuth?: boolean) => {
  const token = withoutAuth ? '' : await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint}${path}`, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify(data),
  }).then((handleErrors)).then((res: any) => res.json());
};

export const postV2 = async (path: string, data: any, withoutAuth?: boolean) => {
  const token = withoutAuth ? '' : await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint2}${path}`, {
    method: 'POST',
    headers: getHeadersV2(token),
    body: JSON.stringify(data),
  }).then((handleErrors)).then((res: any) => res.json());
};


export const postWithFile = async (path: string, data: any, withoutAuth?: boolean) => {
  const token = withoutAuth ? '' : await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint}${path}`, {
    method: 'POST',
    headers: getCsvHeaders(token),
    body: data,
  }).then(handleErrors).then((res: any) => res.json());
};

export const postWithBlob = (path: string, data: any, blob: {
  [s: string]: Blob,
}) => {
  const fd = jsonToFormData(data);
  fd.append(Object.keys(blob)[0], Object.values(blob)[0], `${Object.keys(blob)[0]}.jpeg`);
  return fetch(`${CONSTANTS.apiEndPoint}${path}`, {
    method: 'POST',
    headers: getFormDataHeaders(),
    body: fd,
  }).then((handleErrors)).then((res: any) => res.json());
};

export const put = async (path: string, data: any) => {
  const token = await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint}${path}`, {
    method: 'PUT',
    headers: getHeaders(token),
    body: JSON.stringify(data),
  }).then((handleErrors)).then((res: any) => res.json());
};

export const putWithBlob = (path: string, data: any, blob?: {
  [s: string]: Blob,
}) => {
  const fd = jsonToFormData(data);
  blob && fd.append(Object.keys(blob)[0], Object.values(blob)[0], `${Object.keys(blob)[0]}.jpeg`);
  return fetch(`${CONSTANTS.apiEndPoint}${path}/${data.id}`, {
    method: 'PUT',
    headers: getFormDataHeaders(),
    body: fd,
  }).then((handleErrors)).then((res: any) => res.json());
};

export const del = async (path: string, id: string) => {
  const token = await AuthService.getSessionToken();
  return fetch(`${CONSTANTS.apiEndPoint}${path}/${id}`, {
    method: 'DELETE',
    headers: getHeaders(token),
  }).then((handleErrors)).then((res: any) => res.json());
};

function buildFormData(formData: any, data: any, parentKey?: any) {
  if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
    });
  } else {
    const value = data == null ? '' : data;
    formData.append(parentKey, value);
  }
}

function jsonToFormData(data: any) {
  const formData = new FormData();
  buildFormData(formData, data);
  return formData;
}

const ApiService = {
  get, post, postV2, postWithFile, put, del,
};

export default ApiService;
